import { PrototypeAiRenderEditor } from './ai-render-editor';
import type { AiRenderSettings } from './ai-render-settings';
import { RichText } from './rich-text';

/** The AI disclaimer on the renders and in the fullscreen popup: shown on every render the panel does not hide it on, in the shared text. */
export class AiDisclaimer {
    /** The copy as the markup ships it, as rich text; read before anything changes it. */
    public static defaultText(root: HTMLElement): string {
        return RichText.sanitize(AiDisclaimer.textOf(root.querySelector('.ai-slider-label'))?.innerHTML.trim() ?? '');
    }

    public static apply(root: HTMLElement, settings: AiRenderSettings, defaultText: string) {
        const text = RichText.sanitize(settings.text ?? defaultText);
        const empty = RichText.isEmpty(text);
        root.querySelectorAll<HTMLElement>('.ai-slider-label').forEach(label => {
            const item = label.closest('.ai-slider-item');
            label.hidden = empty || (item !== null && settings.hidden.includes(PrototypeAiRenderEditor.renderNumber(item)));
            const span = AiDisclaimer.textOf(label);
            span?.replaceChildren(RichText.fragment(text));
        });

        const popupLine = root.querySelector<HTMLElement>('.popup-ai-disclaimer');
        const popupText = AiDisclaimer.textOf(popupLine);
        popupText?.replaceChildren(RichText.fragment(text));
        if (popupLine) {
            popupLine.hidden = empty;
        }
    }

    private static textOf(line: Element | null): HTMLElement | null {
        return line?.querySelector<HTMLElement>(':scope > span:not(.icon)') ?? null;
    }
}
